import React from 'react';
import { motion } from 'framer-motion';

const LabsHero: React.FC = () => {
  return (
    <section id="hero" className="relative min-h-screen flex flex-col overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-[#0A0A0F]">
        <div
          className="absolute inset-0 opacity-[0.02]"
          style={{
            backgroundSize: '80px 80px',
            backgroundImage:
              'linear-gradient(to right, #3B82F6 1px, transparent 1px), linear-gradient(to bottom, #3B82F6 1px, transparent 1px)',
          }}
        />
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-[#3B82F6]/8 rounded-full blur-[160px]" />
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-[#8B5CF6]/6 rounded-full blur-[140px]" />
      </div>

      {/* Announcement bar */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="relative z-10 flex justify-center pt-24 pb-4"
      >
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#3B82F6]/50 border border-[#3B82F6]/15 rounded-full px-5 py-1.5">
          Noa Partners → Noa Labs
        </span>
      </motion.div>

      {/* Split layout */}
      <div className="relative z-10 flex-1 flex items-center">
        <div className="w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            {/* Left — massive headline */}
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
            >
              <h1 className="font-space-grotesk text-7xl sm:text-8xl lg:text-9xl font-bold text-white leading-[0.9] tracking-tight">
                Noa
                <br />
                Labs
              </h1>
              <div className="mt-6 w-16 h-[2px] bg-gradient-to-r from-[#3B82F6] to-[#8B5CF6]" />
              <p className="mt-4 text-[#A1A1AA]/50 text-sm max-w-xs">
                The intelligence layer on top of Latin America's mission-critical software.
              </p>
            </motion.div>

            {/* Right — copy + CTAs */}
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.6, duration: 0.8 }}
              className="space-y-8"
            >
              <p className="text-lg sm:text-xl text-[#A1A1AA] leading-relaxed">
                We acquire{' '}
                <span className="text-white font-medium">mission-critical systems of record</span>{' '}
                — then build AI-powered revenue engines on top of them.
              </p>

              <p className="text-sm text-[#A1A1AA]/60 leading-relaxed max-w-lg">
                We're recruiting exceptional builders to create the intelligence layer on top of our portfolio companies — turning built-in distribution, proprietary data, and deep workflow integration into standalone AI businesses.
              </p>

              <div className="flex flex-wrap gap-4">
                <a
                  href="#verticals"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('verticals')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-gradient-to-r from-[#3B82F6] to-[#8B5CF6] text-white font-medium text-sm hover:shadow-[0_0_40px_rgba(59,130,246,0.25)] transition-shadow"
                >
                  Explore Verticals
                </a>
                <a
                  href="#builder"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('builder')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/15 text-white/70 font-medium text-sm hover:border-white/30 hover:text-white transition-all"
                >
                  Become a Builder
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LabsHero;
